<template>
  <div class="flex flex-col w-full">
    <div class="flex fixed top-0 left-0 w-full z-50">
      <tab-button
        v-for="(tab, index) in props.tabs"
        :key="index"
        @click="selectTab(index)"
        :selected="currentTab === index"
        :text="tab.label"
        class="flex-1 text-center"
      ></tab-button>
    </div>
    <div class="pt-12">
      <component :is="currentComponent.component" :category="currentComponent.category" />
    </div>
  </div>
</template>

<script setup>
import TabButton from '@/components/TabButton.vue'
import { ref, computed } from 'vue'

const props = defineProps({
  tabs: {
    type: Array,
    required: true
  }
})

const currentTab = ref(0)

const currentComponent = computed(() => {
  return props.tabs[currentTab.value]
})

const selectTab = (index) => {
  currentTab.value = index
}
</script>
